import _ from 'lodash'
import codeTools from '../codes'
import dictionary from '../../store/dictionary'

const filterOptions = {
    content_type: [
        {
            id: 'post',
            title: 'Post',
            isEnabled({ platformId }) {
                return ['twitter', 'instagram'].includes(platformId)
            },
        },
        {
            id: 'video',
            title: 'Video',
            isEnabled({ platformId }) {
                return ['youtube', 'tiktok'].includes(platformId)
            },
        },
        {
            id: 'video',
            title: 'Reel',
            isEnabled({ platformId }) {
                return ['instagram'].includes(platformId)
            },
        },
        {
            id: 'short',
            title: 'Short',
            isEnabled({ platformId }) {
                return ['youtube'].includes(platformId)
            },
        },
        {
            id: 'stream',
            title: 'Stream',
            isEnabled({ platformId }) {
                return ['twitch', 'youtube'].includes(platformId)
            },
        },
        // {
        //     id: 'image',
        //     title: 'Photo',
        //     isEnabled({ platformId }) {
        //         return ['instagram'].includes(platformId)
        //     },
        // },
        // {
        //     id: 'carousel',
        //     title: 'Carousel',
        //     isEnabled({ platformId }) {
        //         return ['instagram'].includes(platformId)
        //     },
        // },
    ],
}

const filterDefaults = {
    content_type: null,
    day_range: '365',

    account_made_for_kids: null,
    email: null,
    account_rating_remapped: null,
    account_type: null,
    age_range: null,
    alternate_platforms: {
        include: {
            values: [],
            conjunction: '$or',
            specifics: {},
        },
        exclude: {
            values: [],
            conjunction: '$nin',
            specifics: {},
        },
    },
    excluded_list_id: [],
    avg_comments: {
        min: 0,
        max: 1_000_000,
    },
    avg_engagement_rate: {
        min: 0,
        max: 1,
    },
    avg_likes: {
        min: 0,
        max: 10_000_000,
    },
    avg_views: {
        min: 0,
        max: 1_000_000_000,
    },
    avg_viewers: {
        min: 0,
        max: 10_000,
    },
    classifications: {
        hierarchy: {
            topic: null,
            category: null,
            index: null,
        },
        conjunction: '$and',
        primary_only: false,
    },
    // Family/appearance
    has_children: null,
    has_relationship: null,
    relationship_status: [],
    is_vtuber: null,
    shows_face: null,
    has_sponsorship: null,
    is_ai_generated_influencer: null,
    is_not_ai_generated_influencer: null,
    // Business collaborations (include + exclude)
    collaborations: {
        include: {
            values: [],
            conjunction: '$or',
        },
        exclude: {
            values: [],
            conjunction: '$or',
        },
    },
    // Residence city (string code list like "City, CC")
    residence_city: [],
    // Education (nested include)
    education_institution: {
        include: {
            values: [],
            conjunction: '$or',
        },
    },
    education_field: {
        include: {
            values: [],
            conjunction: '$or',
        },
    },
    // Career (nested include)
    career_role: {
        include: {
            values: [],
            conjunction: '$or',
        },
    },
    career_industry: {
        include: {
            values: [],
            conjunction: '$or',
        },
    },
    career_company: {
        include: {
            values: [],
            conjunction: '$or',
        },
    },
    career_current_only: null,
    content_formats: {
        include: {
            values: [],
            conjunction: '$or',
            // specifics: {},
        },
        exclude: {
            values: [],
            conjunction: '$nin',
            // specifics: {},
        },
    },
    email_domain: null,
    followers: {
        min: 0,
        max: 1_000_000_000,
    },
    games_count: {
        min: 0,
        max: 10000,
    },
    games_list_matched_count: {
        min: 0,
        // max: 10000,
    },
    games_list: {
        include: {
            values: [],
            conjunction: '$or',
            specifics: {},
        },
        exclude: {
            values: [],
            conjunction: '$nin',
            specifics: {},
        },
    },
    game_categories_list: {
        include: {
            values: [],
            conjunction: '$or',
        },
        exclude: {
            values: [],
            conjunction: '$nin',
        },
    },
    country: [],
    exclude_country: [],
    region: [],
    gender: [],
    language: [],
    exclude_language: [],
    hashtags_count: {
        min: 0,
        max: 1000,
    },
    hashtags_list: {
        include: {
            values: [],
            conjunction: '$or',
            specifics: {},
        },
        exclude: {
            values: [],
            conjunction: '$or',
            specifics: {},
        },
    },
    interests: {
        include: {
            values: [],
            conjunction: '$or',
        },
        exclude: {
            values: [],
            conjunction: '$or',
        },
    },
    semantic_interests: {
        include: {
            values: [],
            conjunction: '$or',
        },
        exclude: {
            values: [],
            conjunction: '$or',
        },
    },
    sponsorship_saturation: {
        min: 0,
        max: 1,
    },
    sum_content_items: {
        min: 0,
        max: 500,
    },
    sum_views: {
        min: 0,
        max: 10_000_000_000,
    },
    audience_age_ranges: {
        include: {
            values: [],
            conjunction: '$or',
        },
    },
    audience_brand_safety: {
        min: 0,
        max: 1,
    },
    audience_cohesion_score: {
        min: 0,
        max: 1,
    },
    audience_countries: {
        include: {
            values: [],
            conjunction: '$or',
            specifics: {},
        },
    },
    audience_education_level: {
        include: {
            values: [],
            conjunction: '$or',
        },
    },
    audience_engagement_style: {
        include: {
            values: [],
            conjunction: '$or',
        },
    },
    audience_ethnicity_distribution: {
        include: {
            values: [],
            conjunction: '$or',
        },
    },
    audience_family_status: {
        include: {
            values: [],
            conjunction: '$or',
        },
    },
    audience_gender_distribution: {
        include: {
            values: [],
            conjunction: '$or',
        },
    },
    audience_income_distribution: {
        include: {
            values: [],
            conjunction: '$or',
        },
    },
    audience_languages: {
        include: {
            values: [],
            conjunction: '$or',
        },
    },
    audience_occupation_distribution: {
        include: {
            values: [],
            conjunction: '$or',
        },
    },
    audience_toxicity_score: {
        min: 0,
        max: 1,
    },
}

const filterLabels = {
    day_range: 'Timeframe',
    content_type: 'Format',
    excluded_list_id: 'Exclude creators in list',
    'classifications.hierarchy.topic': 'Niche',
    'classifications.hierarchy.category': 'Niche category',
    'classifications.primary_only': 'Main niche only',
    'games_list.include.values': 'Games',
    'games_list.exclude.values': 'Excluded games',
    'games_list_matched_count.min': 'Minimum matching games',
    'games_count.min': 'Minimum games covered',
    'game_categories_list.include.values': 'Game tags',
    'game_categories_list.exclude.values': 'Excluded game tag',
    'semantic_interests.include.values': 'Interests',
    'semantic_interests.exclude.values': 'Excluded interests',
    'interests.include.values': 'Interests',
    'interests.exclude.values': 'Excluded interests',
    'hashtags_list.include.values': 'Hashtag',
    'hashtags_list.exclude.values': 'Excluded hashtag',
    'content_formats.include.values': 'Content style',
    'content_formats.exclude.values': 'Excluded content style',
    account_rating_remapped: 'Content rating',
    has_sponsorship: 'Has sponsored content',
    avg_views: 'Avg. views',
    avg_likes: 'Avg. likes',
    avg_engagement_rate: 'Engagement rate',
    followers: 'Followers',
    sum_content_items: 'Minimum posts',
    account_type: 'Account type',
    'alternate_platforms.include.values': 'Other Socials',
    language: 'Language',
    exclude_language: 'Excluded language',
    country: 'Country',
    exclude_country: 'Excluded country',
    region: 'region',
    residence_city: 'City',
    gender: 'Gender',
    age_range: 'Age range',
    email: 'Has email address',
    has_relationship: 'In a relationship',
    relationship_status: 'Relationship status',
    has_children: 'Parent creator',
    shows_face: 'Shows face',
    is_vtuber: 'Vtubers only',
    is_not_vtuber: 'Exclude VTubers',
    is_ai_generated_influencer: 'AI accounts',
    is_not_ai_generated_influencer: 'Exclude AI accounts',
    account_made_for_kids: 'Made for kids',
    'education_institution.include.values': 'Education — Institutions',
    'education_field.include.values': 'Education — Fields of Study',
    'career_role.include.values': 'Career — Roles',
    'career_industry.include.values': 'Career — Industries',
    'career_company.include.values': 'Career — Companies',
    career_current_only: 'Current job only',
    'collaborations.include.values': 'Collaborations',
    'collaborations.exclude.values': 'Exclude Collaborations',
    'audience_countries.include.values': 'Countries',
    'audience_languages.include.values': 'Languages',
    'audience_gender_distribution.include.values': 'Genders',
    'audience_age_ranges.include.values': 'Age Ranges',
    'audience_ethnicity_distribution.include.values': 'Ethnicities',
    'audience_education_level.include.values': 'Education levels',
    'audience_family_status.include.values': 'Family status',
    'audience_income_distribution.include.values': 'Income ranges',
    'audience_occupation_distribution.include.values': 'Occupations',
    'audience_engagement_style.include.values': 'Engagement Styles',
}

const targetGroups = {
    createDiscoveryFilters(platformId) {
        const options = _.mapValues(filterOptions, (optionValue) => {
            if (_.isArray(optionValue)) {
                return _.reduce(optionValue, (result, value) => {
                    if (value.isEnabled({ platformId })) {
                        result.push(_.omit(value, ['isEnabled']))
                    }

                    return result
                }, [])
            }

            return optionValue
        })

        const labels = _.cloneDeep(filterLabels)
        labels.followers = platformId === 'youtube' ? 'Subscribers' : 'Followers'

        return {
            // We limit options by platform
            options: _.assign(_.cloneDeep(filterDefaults), options),

            // Defaults are not affected by options
            default: _.cloneDeep(filterDefaults),

            // Shared display labels for filters outside the main filter UI
            labels,
        }
    },

    mapTargetGroupFromFilters(targetGroup, codeLookup, defaults) {
        let group = {}

        if (targetGroup.platform === 'twitch') {
            group = _.cloneDeep(defaults.twitch)
        } else if (targetGroup.platform === 'youtube') {
            group = _.cloneDeep(defaults.youtube)
        } else if (targetGroup.platform === 'tiktok') {
            group = _.cloneDeep(defaults.tiktok)
        } else if (targetGroup.platform === 'twitter') {
            group = _.cloneDeep(defaults.twitter)
        } else if (targetGroup.platform === 'instagram') {
            group = _.cloneDeep(defaults.instagram)
        }

        group.title = targetGroup.title
        group.id = targetGroup.id
        group.version = targetGroup.version
        group.platform = targetGroup.platform
        group.entityType = targetGroup.entityType
        group.entityId = targetGroup.entityId

        _.forEach(targetGroup.filters, (filter) => {
            switch (filter.id) {
                case 'industry':
                    group.industry = filter.value
                    break

                case 'day_range':
                    group.day_range = filter.value
                    break

                case 'interests':
                    if (group?.interests) {
                        group.interests.values = codeTools.getCodesFromLookup(
                            filter.value,
                            targetGroup.platform,
                            'interest',
                            codeLookup,
                        )
                    }

                    break
                case 'games':
                    if (group?.games) {
                        group.games.values = codeTools.getCodesFromLookup(
                            filter.value,
                            targetGroup.platform,
                            'game',
                            codeLookup,
                        )
                    }

                    break
                case 'games-conjunction':
                    if (group?.games) {
                        group.games.conjunction = filter.value
                    }

                    break
                case 'min-matched-games':
                    if (group?.matched_games) {
                        group.matched_games.min = filter.value
                    }

                    break
                case 'not-games':
                    if (group?.not_games) {
                        group.not_games.values = codeTools.getCodesFromLookup(
                            filter.value,
                            targetGroup.platform,
                            'game',
                            codeLookup,
                        )
                    }
                    break
                case 'not-games-conjunction':
                    if (group?.not_games) {
                        group.not_games.conjunction = filter.value
                    }
                    break
                case 'min-content':
                    group.content_count.min = filter.value
                    break
                case 'tags':
                    group.tags.values = codeTools.getCodesFromLookup(
                        filter.value,
                        targetGroup.platform,
                        'tag',
                        codeLookup,
                    )
                    break
                case 'tags-conjunction':
                    if (group?.tags) {
                        group.tags.conjunction = filter.value
                    }

                    break
                case 'languages':
                    group.languages = codeTools.getCodesFromLookup(
                        filter.value,
                        targetGroup.platform,
                        'language',
                        codeLookup,
                    )
                    break
                case 'country':
                    group.country = codeTools.getCodesFromLookup(
                        filter.value,
                        targetGroup.platform,
                        'country',
                        codeLookup,
                    )
                    break
                case 'min-viewers':
                    group.avg_viewers.min = filter.value
                    break
                case 'max-viewers':
                    group.avg_viewers.max = filter.value
                    break
                case 'min-engagement-rate':
                    group.engagement_rate.min = filter.value
                    break
                case 'max-engagement-rate':
                    group.engagement_rate.max = filter.value
                    break
                case 'min-followers':
                    group.followers.min = filter.value
                    break
                case 'max-followers':
                    group.followers.max = filter.value
                    break
                case 'min-game-affinity':
                    console.log('mapTargetGroupFromFilters', 'min-game-affinity', filter.value)

                    if (group?.affinity?.game && group?.affinity?.game?.min > 0) {
                        group.affinity.game.min = filter.value
                    }
                    break
                case 'max-game-affinity':
                    console.log('mapTargetGroupFromFilters', 'max-game-affinity', filter.value)

                    if (group?.affinity?.game && group?.affinity?.game?.max > 0 && group?.affinity?.game?.max < 1) {
                        group.affinity.game.max = filter.value
                    }
                    break
                case 'min-games':
                    if (group?.games) {
                        group.games.min = filter.value
                    }
                    break
                case 'max-games':
                    if (group?.games) {
                        group.games.max = filter.value
                    }
                    break
                case 'has-email':
                    group.metadata.email = filter.value
                    break
                case 'has-location':
                    if (group?.metadata) {
                        group.metadata.location = filter.value
                    }
                    break
                case 'channel-types':
                    if (group?.metadata) {
                        group.metadata.type = codeTools
                            .getCodesFromLookup(filter.value, targetGroup.platform, 'channelType', codeLookup)
                            .map((code) => ({
                                ...code,
                                label: dictionary.state.superview.type[code.name].label,
                            }))
                    }
                    break
                case 'min-views':
                    group.avg_views.min = filter.value
                    break
                case 'max-views':
                    group.avg_views.max = filter.value
                    break
                case 'min-likes':
                    group.avg_likes.min = filter.value
                    break
                case 'max-likes':
                    group.avg_likes.max = filter.value
                    break
                case 'min-subscribers':
                    group.subscribers.min = filter.value
                    break
                case 'max-subscribers':
                    group.subscribers.max = filter.value
                    break
                case 'content-type':
                    group.content_type = filter.value
                    break
                case 'gender':
                    group.gender = codeTools.getCodesFromLookup(
                        filter.value,
                        targetGroup.platform,
                        'gender',
                        codeLookup,
                    )
                    break
                case 'age-ranges':
                    group.gender = codeTools.getCodesFromLookup(
                        filter.value,
                        targetGroup.platform,
                        'age-range',
                        codeLookup,
                    )
                    break
                case 'categories':
                    group.categories.values = this.loadCodeWithValue2(
                        filter.value,
                        targetGroup.platform,
                        'category',
                        codeLookup,
                    )
                    break
                case 'categories-conjunction':
                    group.categories.conjunction = filter.value
                    break
                case 'not-categories':
                    group.not_categories.values = this.loadCodeWithValue2(
                        filter.value,
                        targetGroup.platform,
                        'category',
                        codeLookup,
                    )
                    break
                case 'not-categories-conjunction':
                    group.not_categories.conjunction = filter.value
                    break
                case 'demographics-os':
                    group.demographics.os.values = this.loadCodeWithValue2(
                        filter.value,
                        targetGroup.platform,
                        'operating-system',
                        codeLookup,
                    )
                    break
                case 'demographics-os-conjunction':
                    group.demographics.os.conjunction = filter.value
                    break
                case 'demographics-country':
                    group.demographics.country.values = this.loadCodeWithValue2(
                        filter.value,
                        targetGroup.platform,
                        'country',
                        codeLookup,
                    )
                    break
                case 'demographics-country-conjunction':
                    group.demographics.country.conjunction = filter.value
                    break
                case 'demographics-device':
                    group.demographics.device.values = this.loadCodeWithValue2(
                        filter.value,
                        targetGroup.platform,
                        'device-type',
                        codeLookup,
                    )
                    break
                case 'demographics-device-conjunction':
                    group.demographics.device.conjunction = filter.value
                    break
                case 'demographics-language':
                    group.demographics.language.values = this.loadCodeWithValue2(
                        filter.value,
                        targetGroup.platform,
                        'language',
                        codeLookup,
                    )
                    break
                case 'demographics-language-conjunction':
                    group.demographics.language.conjunction = filter.value
                    break
                default:
                    break
            }
        })

        return group
    },

    mapFiltersFromTargetGroup(values, options) {
        const filters = []

        if (options.industry && values?.industry) {
            filters.push({ id: 'industry', value: values.industry })
        }

        if (options.day_range && values?.day_range) {
            filters.push({ id: 'day_range', value: values.day_range })
        }
        if (options.content_count && values?.content_count?.min) {
            filters.push({ id: 'min-content', value: values.content_count.min })
        }
        if (options.languages) {
            filters.push({ id: 'languages', value: _.map(values.languages, 'id') })
        }
        if (options.interests && values?.interests?.values) {
            filters.push({ id: 'interests', value: _.map(values.interests.values, 'id') })
        }
        if (options.interests && values?.interests?.conjunction) {
            filters.push({ id: 'interests-conjunction', value: values.interests.conjunction })
        }
        if (options.semantic_interests && values?.semantic_interests?.values) {
            filters.push({ id: 'semantic_interests', value: _.map(values.semantic_interests.values, 'id') })
        }
        if (options.semantic_interests && values?.semantic_interests?.conjunction) {
            filters.push({ id: 'semantic_interests-conjunction', value: values.semantic_interests.conjunction })
        }
        if (options.games && values?.games?.values) {
            filters.push({ id: 'games', value: _.map(values.games.values, 'id') })
        }
        if (options.games && values?.games?.conjunction) {
            filters.push({ id: 'games-conjunction', value: values.games.conjunction })
        }
        if (options.matched_games && values?.matched_games?.min) {
            filters.push({ id: 'min-matched-games', value: values.matched_games.min })
        }
        if (options.not_games && values?.not_games?.values) {
            filters.push({ id: 'not-games', value: _.map(values.not_games.values, 'id') })
        }
        if (options.not_games && values?.not_games?.conjunction) {
            filters.push({ id: 'not-games-conjunction', value: values.not_games.conjunction })
        }
        if (options.avg_viewers && values?.avg_viewers?.min) {
            filters.push({ id: 'min-viewers', value: values.avg_viewers.min })
        }
        if (options.avg_viewers && values?.avg_viewers?.max) {
            filters.push({ id: 'max-viewers', value: values.avg_viewers.max })
        }

        if (options.followers && values?.followers?.min) {
            filters.push({ id: 'min-followers', value: values.followers.min })
        }
        if (options.followers && values?.followers?.max) {
            filters.push({ id: 'max-followers', value: values.followers.max })
        }

        if (options.engagement_rate && values?.engagement_rate?.min) {
            filters.push({ id: 'min-engagement-rate', value: values.engagement_rate.min })
        }
        if (options.engagement_rate && values?.engagement_rate?.max) {
            filters.push({ id: 'max-engagement-rate', value: values.engagement_rate.max })
        }

        if (
            options?.affinity?.game &&
            typeof values?.affinity?.game?.min === 'number' &&
            values?.affinity?.game?.min > 0
        ) {
            console.log('mapFiltersFromTargetGroup', values.affinity.game.min)

            filters.push({ id: 'min-game-affinity', value: values.affinity.game.min })
        }

        if (
            options?.affinity?.game &&
            typeof values?.affinity?.game?.max === 'number' &&
            values?.affinity?.game?.max < 1
        ) {
            console.log('mapFiltersFromTargetGroup', values.affinity.game.max)
            filters.push({ id: 'max-game-affinity', value: values.affinity.game.max })
        }

        if (options?.games && values?.games?.min) {
            filters.push({ id: 'min-games', value: values.games.min })
        }
        if (options?.games && values?.games?.max) {
            filters.push({ id: 'max-games', value: values.games.max })
        }
        if (options?.metadata && values?.metadata?.email) {
            filters.push({ id: 'has-email', value: values.metadata.email })
        }
        if (options?.metadata && values?.metadata?.location) {
            filters.push({ id: 'has-location', value: values.metadata.location })
        }
        if (options?.tags && values?.tags?.values) {
            filters.push({ id: 'tags', value: _.map(values.tags.values, 'id') })
        }
        if (options?.tags && values?.tags?.conjunction) {
            filters.push({ id: 'tags-conjunction', value: values.tags.conjunction })
        }
        if (options?.country) {
            filters.push({ id: 'country', value: _.map(values.country, 'id') })
        }
        if (options?.avg_views && values?.avg_views?.min) {
            filters.push({ id: 'min-views', value: values.avg_views.min })
        }
        if (options?.avg_views && values?.avg_views?.max) {
            filters.push({ id: 'max-views', value: values.avg_views.max })
        }
        if (options?.avg_likes && values?.avg_likes?.min) {
            filters.push({ id: 'min-likes', value: values.avg_likes.min })
        }
        if (options?.avg_likes && values?.avg_likes?.max) {
            filters.push({ id: 'max-likes', value: values.avg_likes.max })
        }
        if (options?.subscribers && values?.subscribers?.min) {
            filters.push({ id: 'min-subscribers', value: values.subscribers.min })
        }
        if (options?.subscribers && values?.subscribers?.max) {
            filters.push({ id: 'max-subscribers', value: values.subscribers.max })
        }
        if (options?.metadata && values?.metadata?.type) {
            filters.push({ id: 'channel-types', value: _.map(values.metadata.type, 'id') })
        }
        if (typeof values.content_type === 'string') {
            filters.push({ id: 'content-type', value: values.content_type })
        }
        if (options?.gender) {
            filters.push({ id: 'gender', value: _.map(values.gender, 'id') })
        }
        if (options?.age_ranges) {
            filters.push({ id: 'age-ranges', value: _.map(values.ageRanges, 'id') })
        }

        if (options.categories) {
            this.appendCodeFilterWithValue2(filters, values.categories, 'categories', 'categories-conjunction')
        }
        if (options.not_categories) {
            this.appendCodeFilterWithValue2(
                filters,
                values.not_categories,
                'not-categories',
                'not-categories-conjunction',
            )
        }

        if (options.demographics && values.demographics) {
            if (options.demographics.os) {
                this.appendCodeFilterWithValue2(
                    filters,
                    values.demographics.os,
                    'demographics-os',
                    'demographics-os-conjunction',
                )
            }
            if (options.demographics.country) {
                this.appendCodeFilterWithValue2(
                    filters,
                    values.demographics.country,
                    'demographics-country',
                    'demographics-country-conjunction',
                )
            }
            if (options.demographics.device) {
                this.appendCodeFilterWithValue2(
                    filters,
                    values.demographics.device,
                    'demographics-device',
                    'demographics-device-conjunction',
                )
            }
            if (options.demographics.language) {
                this.appendCodeFilterWithValue2(
                    filters,
                    values.demographics.language,
                    'demographics-language',
                    'demographics-language-conjunction',
                )
            }
        }

        const mappedGroup = {
            targetGroup: {
                title: values.title,
                filters,
            },
        }

        if (values.id) {
            mappedGroup.targetGroup.id = values.id
        }

        return mappedGroup
    },

    appendCodeFilterWithValue2(filters, values, filterId, conjunctionFilterId) {
        if (!values) {
            return
        }

        if (filterId && values.values) {
            filters.push({
                id: filterId,
                value: _.map(values.values, (value) => {
                    return {
                        id: value.id,
                        value2: value.value2,
                    }
                }),
            })
        }
        if (conjunctionFilterId && values.conjunction) {
            filters.push({ id: conjunctionFilterId, value: values.conjunction })
        }
    },

    loadCodeWithValue2(value, platform, codeType, codeLookup) {
        const ids = _.map(value, (code) => {
            return code.id
        })

        const codesWithValues = codeTools.getCodesFromLookup(ids, platform, codeType, codeLookup)

        _.forEach(codesWithValues, (code) => {
            const matched = _.find(value, (cat) => {
                return cat.id === code.id
            })
            if (matched) {
                code.value2 = matched.value2
            }
        })

        return codesWithValues
    },
}

export default targetGroups
